<div class="container">
    <span class="title">{{title}}</span>
    <span *ngIf="warning" class="text">{{warning}}</span>
    <span *ngIf="bolderBody" class="bolder-text">{{bolderBody}}</span>
    <span class="text">{{body}}</span>
    <span class="checkbox" *ngIf="data.dontShowAgain != ''">
        <ion-checkbox checked="false" color="success" (ionChange)="dontShow($event)"></ion-checkbox>
        <ion-label>Don't show again</ion-label>
    </span>
    <div class="buttons">
        <span class="cancel" 
        *ngIf="cancelText !== ''" 
        (click)="cancel()"
        [ngClass]="cancelButtonClass">{{cancelText.toLowerCase()}}</span>
        <span class="submit" (click)="confirm()">{{okText.toLowerCase()}}</span>
    </div>
</div>
